import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.lg};
`

export const TextRow = styled.div`
  display: flex;
  gap: ${theme.spacing.lg};
`

export const TextCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.lg};
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
`
